import { ColorPicker } from '@components/ArtBoard/ColorLibrary/ColorPicker'
import { useClickOutside } from '@lib/hooks'
import noop from 'lodash/noop'
import type React from 'react'
import { useState } from 'react'

import css from './BackgroundPicker.module.scss'

type Props = {
  hexCode?: string
  onSetColor: (color: string) => void
}

export const BackgroundPicker: React.FC<Props> = ({
  hexCode = '#FFF',
  onSetColor,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false)
  const [colorPickerArea, setColorPickerArea] = useState<HTMLDivElement | null>(
    null
  )

  const clickOutside = useClickOutside<HTMLDivElement>(true, () => {
    setShowColorPicker(false)
  })

  const handleChangeColor = (color: string) => {
    onSetColor(color)
  }

  return (
    <div className={css.wrapper}>
      <span className={css.label}>Background</span>

      <div onClick={clickOutside.onClick} ref={clickOutside.ref}>
        <div
          ref={setColorPickerArea}
          className={css.colorPickArea}
          onClick={() => setShowColorPicker(!showColorPicker)}
        >
          <span className={css.colorName}>{hexCode.replace('#', '')}</span>
          <div className={css.colorDot} style={{ backgroundColor: hexCode }} />
        </div>

        {showColorPicker && (
          <ColorPicker
            colorHex={hexCode}
            colorPikerAreaRef={colorPickerArea}
            onOutsideClick={noop}
            onColorChange={handleChangeColor}
          />
        )}
      </div>
    </div>
  )
}
